import Box from '@mui/material/Box';

import { ScaffolderInputHeader } from '../../../components';
import {
  KubernetesCluster,
  KubernetesClusterPicker,
} from '../../KubernetesClusterPicker';
import { SELF_MANAGED_CLUSTER_INFO } from '../infoDoc';
import { useStyles } from '../styles';
import { SelfManagedCluster } from '../types';
import { NamespaceInput } from './NamespaceInput';

export interface SelfManagedClusterPickerProps {
  formData: SelfManagedCluster;
  onChange: (data: SelfManagedCluster) => void;
  rawErrors: string[];
}

export const SelfManagedClusterPicker = (
  props: SelfManagedClusterPickerProps,
) => {
  const { formData, onChange, rawErrors } = props;
  const { classes } = useStyles();

  const handleClusterChange = (cluster: KubernetesCluster | string = '') => {
    if (!cluster) {
      onChange({ cluster: null, namespaces: [] });
      return;
    }

    onChange({
      cluster:
        typeof cluster === 'string' ? { name: cluster, id: cluster } : cluster,
      namespaces: ['default'],
    });
  };

  const handleNamespacesChanged = (namespaces: string[]) => {
    onChange({
      ...(formData || { cluster: null, namespaces: [] }),
      namespaces,
    });
  };

  return (
    <Box>
      <ScaffolderInputHeader
        title="Cluster"
        description="Select the details for the self-managed cluster."
        infoDoc={SELF_MANAGED_CLUSTER_INFO}
      />
      <Box className={classes.inputContainer}>
        <KubernetesClusterPicker
          title="Cluster Name"
          type="object"
          onlyUserOwned
          formData={formData?.cluster || ''}
          onChange={handleClusterChange}
          rawErrors={rawErrors}
          required
        />
      </Box>
      <NamespaceInput
        formData={formData?.namespaces || []}
        onChange={handleNamespacesChanged}
        rawErrors={rawErrors}
      />
    </Box>
  );
};
